import { useState } from "react";
import { HOT_POSTS } from "@/mocks/home";
import Reveal from "./Reveal";
import SectionHead from "./SectionHead";

const CATS = ["全部", "职场", "社会", "爆料", "数码", "情感"];

export default function HotRank() {
  const [cat, setCat] = useState("全部");
  const list = cat === "全部" ? HOT_POSTS : HOT_POSTS.filter((p) => p.tag === cat);
  const empty = list.length === 0;

  return (
    <section id="hot" className="w-full bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <Reveal>
          <SectionHead
            index="01"
            kicker="Trending"
            title="今日热榜"
            desc="大家都在刷什么？按热度实时排行的论坛热帖与天涯热帖，标题带摘要，扫一眼就知道该不该点进去。"
            action="看更多热帖"
          />
        </Reveal>

        <div className="mt-6 flex flex-wrap items-center gap-2 rounded-full bg-background-200/80 p-1">
          {CATS.map((c) => (
            <button
              key={c}
              type="button"
              onClick={() => setCat(c)}
              className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-2 text-sm font-bold transition-colors ${
                cat === c
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-700 hover:bg-background-50 hover:text-foreground-950"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        <div className="mt-6 flex flex-col gap-3">
          {empty ? (
            <div className="rounded-md border border-background-200 bg-background-50 p-10 text-center text-sm text-foreground-500">
              这个栏目今天还没有新帖，看看其它分类吧。
            </div>
          ) : (
            list.map((p, i) => (
              <Reveal key={p.id} delay={i * 40}>
                <article className="group flex cursor-pointer items-start gap-4 rounded-lg bg-background-50 p-4 transition-colors hover:bg-background-200/50 md:p-5">
                  <div className="flex w-8 shrink-0 flex-col items-center pt-0.5">
                    <span
                      className={`font-heading text-2xl font-black leading-none md:text-3xl ${
                        i === 0 ? "text-accent-600" : "text-secondary-400"
                      }`}
                    >
                      {String(p.id).padStart(2, "0")}
                    </span>
                  </div>

                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="rounded-full bg-primary-50 px-2 py-0.5 text-[11px] font-bold text-primary-600">
                        {p.tag}
                      </span>
                      <span className="text-[11px] text-foreground-500">{p.meta}</span>
                    </div>
                    <h3 className="mt-1.5 text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
                      {p.title}
                    </h3>
                    <p className="mt-1 line-clamp-2 text-sm leading-relaxed text-foreground-600">{p.excerpt}</p>
                  </div>

                  <div className="hidden shrink-0 flex-col items-end gap-1 sm:flex">
                    <span className="flex items-center gap-1 font-heading text-lg font-black text-primary-500">
                      <i className="ri-fire-fill text-sm text-primary-500" />
                      {p.heat}
                    </span>
                    <span className="text-[11px] text-foreground-500">热度</span>
                  </div>

                  <i className="ri-arrow-right-line mt-2 hidden self-start text-foreground-400 transition-transform group-hover:translate-x-0.5 lg:block" />
                </article>
              </Reveal>
            ))
          )}
        </div>
      </div>
    </section>
  );
}